import { useState, useEffect, memo } from "react";
import { useNavigate } from "react-router-dom";
import ClassAppointmentExitPopup from "../PopupModal/EndCallModal";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import { extractInitials } from "../utils/GenericFunction";
import IframeModal from "../PopupModal/IframeModal";
import DrivePlanPopupModal from "../PopupModal/DrivePlanPopup";
import Loader from "../Sub_components/Loader";
import axios from "axios";
import ReactVideoPlayer from "../Sub_components/ReactVideoPlayer";
import { AmplitudeAddLog } from "../utils/AppAmplitude";

function SaveRecordingScreen() {
  const {
    recordedFilePath,
    setRecordedFilePath,
    __merchantId,
    __userId,
    appInsightTrack,
    __appConfirmUniqueID,
    eventType,
    showIframe,
    setShowIframe,
    setShowUrl,
    webUrlSubDomain,
    serverCallId,
    recordingId,
    classesName,
    userNameHost,
    setInformationContent,
    setShowInformationStrip,
    grp,
    apiUrlPost,
    businessURL,
    videoNamePlayback,
    setVideoNamePlayback,
    errorMessage
  } = useLiveStreamAppContext();

  const MAX_ATTEMPTS = 200;
  const DELAY = 30000;

  const handleVideoNameChange = (e) => {
    setVideoNamePlayback(e.target.value);
    if (e.target.value.trim()) {
      setMessageErr("");
    }
  };

  const [exitModalShow, setExitModalShow] = useState(false);
  const navigate = useNavigate();
  const [videoDescription, setVideoDescription] = useState("");
  const [messageErr, setMessageErr] = useState("");

  const [drivePlanModalShow, setDrivePlanModalShow] = useState(false);
  const [vagaroDrivePlanList, setVagaroDrivePlanList] = useState([]);
  const [driveSizeCalculate, setDriveSizeCalculate] = useState(null);

  const [loaderAnimationIOS, setLoaderAnimationIOS] = useState(false);
  const [uploadDriveContainerName, setUploadDriveContainerName] =
    useState(null);
  const [storageDigit, setStorageDigit] = useState(null);
  const [usageStorageDigitInKb, setUsageStorageDigitInKb] = useState(null);
  const [uploadFolderName, setUploadFolderName] = useState(null);
  const [recordingFileNameURLpay, setRecordingFileNameURLpay] = useState(null);

  useEffect(() => {
    if (recordedFilePath && typeof recordedFilePath === "string") {
      const FILE_BASE_URL = process.env.REACT_APP_RECORDING_FILE_BASE_URL;
      if (recordedFilePath.includes(FILE_BASE_URL)) {
        const path = recordedFilePath.split(FILE_BASE_URL)[1];
        setRecordingFileNameURLpay(path);
      }
    }
  }, [recordedFilePath]);

  const headers = {
    "Content-Type": "application/json",
    userId: __userId,
    merchantId: __merchantId,
    employeeId: __userId,
  };

  const handleVideoDescriptionChange = (event) => {
    setVideoDescription(event.target.value);
  };

  useEffect(() => {
    sessionStorage.setItem("end", 1);
  }, []);

  function handleDiscadRecording() {
    const currentPath = window.location.pathname;
    const newPath = currentPath.replace("/recording-playback", "/feedbackhost");
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("hostDiscard", "false");
    const newUrl = newPath + "?" + searchParams.toString();
    navigate(newUrl);
  }

  // Vagaro DriveFlag when Component Mounts after the FilePATH get -----
  const handleVagaroDriveFlag = async () => {
    //("Fetch handleVagaroDriveFlag--");
    try {
      const res = await axios.get(`${apiUrlPost}vagarodriveflag`, { headers });
      if (res?.data?.data?.isVagaroDriveEnable) {
        setUploadDriveContainerName(res.data.data.driveContainerName);
        setUploadFolderName(res.data.data.folderName);
        const folderName = res.data.data.folderName;
        const containerName = res.data.data.driveContainerName;
        if (res?.data?.data?.canModify) {
          handleCalculateVagaroDriveSizeSync(folderName, containerName);
        } else {
          setLoaderAnimationIOS(false);
          setShowInformationStrip(true);
          setInformationContent({
            type: "alert",
            message: "You don't have permission to save in Vagaro Drive.",
          });
          return;
        }
      } else {
        AmplitudeAddLog(
          __userId,
          __merchantId,
          businessURL,
          113,
          grp,
          __appConfirmUniqueID
        );
        if (process.env.REACT_APP_PARENT_DOMAIN?.trim().toLowerCase() === "bookitall.com") {
          setShowUrl(process.env.REACT_APP_WEB_URL_SUBDOMAIN + "ShopOwner/LiveStreamReactVagaroPopup.aspx?popuptype=vagarodrive");
        }
        else {
          setShowUrl("https://" + grp + "." + process.env.REACT_APP_PARENT_DOMAIN + "/ShopOwner/LiveStreamReactVagaroPopup.aspx?popuptype=vagarodrive");
        }
        setShowIframe(true);
      }
    } catch (error) {
      if (error.status === 400 || error.status === 500) {
        console.error(error.message);
        setShowInformationStrip(true);
        setInformationContent({
          type: "alert",
          message: error.message,
        });
      }
      appInsightTrack(
        __merchantId,
        __userId,
        "API Error vagarodriveflag",
        "",
        error
      );
    }
  };

  const fetchRecordingStatus = async () => {
    const payload = {
      serverCallId: serverCallId,
      recordingId: recordingId,
    };
    setLoaderAnimationIOS(true);
    try {
      let attempts = 0;
      while (attempts < MAX_ATTEMPTS && !recordedFilePath) {
        const response = await axios.post(
          `${apiUrlPost}recordedfilestatus`,
          payload,
          { headers }
        );
        if (
          response.data &&
          response.data.data &&
          response.data.data.recordedFilePath
        ) {
          setRecordedFilePath(response.data.data.recordedFilePath);
          setLoaderAnimationIOS(false);
          return; // Exit the function if successful
        } else {
          attempts++;
          await new Promise((resolve) => setTimeout(resolve, DELAY)); // Wait before the next attempt
        }
      }
    } catch (error) {
      if (error.status === 400 || error.status === 500) {
        console.error(error.message);
        setShowInformationStrip(true);
        setInformationContent({
          type: "alert",
          message: error.message,
        });
      }
      appInsightTrack(
        __merchantId,
        __userId,
        "API Error recordedfilestatus",
        "",
        error
      );
      setLoaderAnimationIOS(false);
    }
  };

  // This effect runs when the component mounts and sets the video URL if recordedFilePath is available to stop the loader animation
  useEffect(() => {
    if (recordedFilePath) {
      setLoaderAnimationIOS(false);
    }
  }, [loaderAnimationIOS, recordedFilePath]);

  useEffect(() => {
    AmplitudeAddLog(
      __userId,
      __merchantId,
      businessURL,
      109,
      grp,
      __appConfirmUniqueID
    );
  }, [__userId]);

  useEffect(() => {
    const fetchStatus = async () => {
      if (serverCallId && recordingId) {
        await fetchRecordingStatus();
      } else {
        setLoaderAnimationIOS(false);
        return;
      }
    };
    setLoaderAnimationIOS(true);
    const timer = setTimeout(() => {
      fetchStatus();
    }, 3000);

    return () => {
      clearTimeout(timer);
      setLoaderAnimationIOS(false);
    };
  }, [serverCallId, recordingId]);

  const handleSavetoDrive = async (
    folderName,
    containerName,
    usageStorageDigitInKbMain,
    storageDigitMain
  ) => {
    /*
    request.VagaroDriveUsage  //SEND IN KB
    request.VagaroDrivePlanUsageLimit // SEND IN GB
    */
    const payload = {
      vagaroDriveUsage: usageStorageDigitInKbMain,
      vagaroDrivePlanUsageLimit: storageDigitMain,
      appConfirmUniqueId: __appConfirmUniqueID,
      businessContainer: containerName,
      activeDriveFolderName: folderName,
      eventType: eventType === 1 ? 1 : 2,
      recordingFileName: recordingFileNameURLpay,
      uploadedFileName: videoNamePlayback?.trim(),
      encodingStatus: 1,
      videoFileDescription: videoDescription,
    };
    setLoaderAnimationIOS(true);
    try {
      const response = await axios.post(
        `${apiUrlPost}uploadrecording`,
        payload,
        { headers }
      );
      const canModifyRes = response.data.data.canModify;
      // Dispose or reset sensitive data after use
      payload.vagaroDriveUsage = null;
      payload.vagaroDrivePlanUsageLimit = null;
      payload.appConfirmUniqueId = null;
      payload.businessContainer = null;
      payload.activeDriveFolderName = null;
      payload.eventType = null;
      payload.recordingFileName = null;
      payload.uploadedFileName = null;
      payload.encodingStatus = null;
      payload.videoFileDescription = null;

      if (response.status === 200) {
        setLoaderAnimationIOS(false);
        if (canModifyRes === false) {
          setShowInformationStrip(true);
          setInformationContent({
            type: "alert",
            message: "You don't have permission to save in Vagaro Drive.",
          });
          return;
        } else if (response.data.data.IsDriveInactive) {
          setShowInformationStrip(true);
          setInformationContent({
            type: "alert",
            message: "Your live stream recording has not been saved yet. Please try again after 1 minute.",
          });
          return;
        }
        else {
          const currentPath = window.location.pathname;
          const newPath = currentPath.replace(
            "/recording-playback",
            "/feedbackhost"
          );
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.set("hostDiscard", "true");
          const newUrl = newPath + "?" + searchParams.toString();
          navigate(newUrl);
        }
      }
    } catch (error) {
      if (error.status === 400 || error.status === 500) {
        console.error(error.message);
        setShowInformationStrip(true);
        setInformationContent({
          type: "alert",
          message: error.message,
        });
      }
      appInsightTrack(
        __merchantId,
        __userId,
        "API Error uploadrecording",
        "",
        error
      );
      setLoaderAnimationIOS(false);
    }
  };

  //Vagaro Api call for Drive full Popup
  const handleCalculateVagaroDriveSizeSync = async (
    folderName,
    containerName
  ) => {
    if (videoNamePlayback?.length === 0) {
      setMessageErr("Video name cannot be empty.");
      return;
    }
    setLoaderAnimationIOS(true);
    try {
      const response = await axios.get(
        `${apiUrlPost}calculatevagarodrivesizeandsync`,
        { headers }
      );
      setDriveSizeCalculate(response.data.data.driveSizeCalculate);
      setVagaroDrivePlanList(response.data.data.drivePlanList);

      const defaultPlanStorage = response.data.data.drivePlanList.find(
        (plan) => plan.isSelected
      );

      if (defaultPlanStorage) {
        const totalUsageUse =
          response.data.data.driveSizeCalculate?.appointmentFileUsage +
          response.data.data.driveSizeCalculate?.businessFileUsage +
          response.data.data.driveSizeCalculate?.classFileUsage +
          response.data.data.driveSizeCalculate?.customerFileUsage +
          response.data.data.driveSizeCalculate?.formsFileUsage;

        const TotalStorage = parseInt(
          defaultPlanStorage.usageLimit * 1024 * 1024
        );
        const TotalStorageDrive = parseInt(totalUsageUse);
        setStorageDigit(defaultPlanStorage.usageLimit);
        const storageDigitMain = defaultPlanStorage.usageLimit;
        let usageStorageDigitInKbMain;
        if (totalUsageUse !== 0) {
          setUsageStorageDigitInKb(totalUsageUse / 1024);
          usageStorageDigitInKbMain = totalUsageUse / 1024;
        } else {
          setUsageStorageDigitInKb(totalUsageUse);
          usageStorageDigitInKbMain = totalUsageUse;
        }
        if (TotalStorageDrive >= TotalStorage && __merchantId != 'yTd~LxbrSI1orNNvYuMiaQ==') {
          AmplitudeAddLog(
            __userId,
            __merchantId,
            businessURL,
            114,
            grp,
            __appConfirmUniqueID
          );
          setDrivePlanModalShow(true);
        } else {
          // Check for iPhone/iPad/Macintosh and exclude certain apps
          const userAgent = navigator.userAgent;
          const isTouchDevice = (navigator.maxTouchPoints || 0) > 1;
          const isExcludedApp =
            userAgent.indexOf("com.vagaro.customerios") > -1 ||
            userAgent.indexOf("com.vagaro.iospro") > -1;

          // Check the condition for specific devices and apps
          if (
            /iPhone|iPad|Macintosh/i.test(userAgent) &&
            isTouchDevice &&
            !isExcludedApp
          ) {
            await handleSavetoDrive(
              folderName,
              containerName,
              usageStorageDigitInKbMain,
              storageDigitMain
            );
          } else {
            await handleSavetoDrive(
              folderName,
              containerName,
              usageStorageDigitInKbMain,
              storageDigitMain
            );
          }
        }
        setLoaderAnimationIOS(false);
      }
    } catch (error) {
      setShowInformationStrip(true);
      setInformationContent({
        type: "alert",
        message: error.message,
      });
      console.error("Error calculating drive size:", error);
      appInsightTrack(
        __merchantId,
        __userId,
        "API Error calculatevagarodrivesizeandsync",
        "",
        error
      );
    }
    setLoaderAnimationIOS(false);
  };

  return (
    <>
      {loaderAnimationIOS && <Loader />}
      <div
        id="savevideopopup"
        className="save-video saveVideoPopupEdnClass"
        style={{ display: "block" }}
      >
        <div className="save-video-wrapper">
          <a href className="close-icon">
            <i
              className="fas fa-times font-awesome-normal-pro"
              aria-hidden="true"
            ></i>
          </a>
          <div className="col-video">
            <section className="section-video">
              <div className="block-video">
                <div className="video-size">
                  <div className="video-size-content">
                    {recordedFilePath ? (
                      <ReactVideoPlayer
                        videoSrc={recordedFilePath}
                        showControls={true}
                      />
                    ) : (
                      <video
                        id="psp-video-preview"
                        className="video-js video-p"
                        data-setup='{"controlBar": {"pictureInPictureToggle": false}}'
                        playsInline
                      >
                        <source src={""} />
                      </video>
                    )}
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="col-details">
            <div className="section-video-details input-view-on-mobile">
              <div className="horizontal_name_class">
                <div className="avatar-size">
                  <div id="divPreviewServiceProvideravtar" className="avatar">
                    <div
                      id="divPreviewServiceProviderInitial"
                      className="initialspusername"
                    >
                      {extractInitials(userNameHost)}
                    </div>
                  </div>
                </div>
                <div className="live-stream-details">
                  <span id="spnServiceName" className="live-stream-name">
                    {classesName}
                  </span>
                  <span id="spnInstructorName" className="avatar-name">
                    {userNameHost}
                  </span>
                </div>
              </div>
              <div className="label-and-field">
                <label>Video Name:</label>
                <input
                  type="text"
                  id="txtvideoname"
                  maxLength="95"
                  placeholder="Enter the File Name."
                  value={videoNamePlayback}
                  onChange={(e) => handleVideoNameChange(e)}
                  className="input-w100per-mobile custom-select"
                />
                <span style={{ color: "red" }}>{messageErr}</span>
              </div>
              <div className="label-and-field video_descri_class">
                <label>Video Description:</label>
                <textarea
                  id="txtvideodescription"
                  maxLength="2000"
                  placeholder="Enter video description."
                  value={videoDescription}
                  onChange={(e) => handleVideoDescriptionChange(e)}
                  className="input-w100per-mobile custom-select"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        {!errorMessage && (
          <div className="save-vdo-fot">
            <div className="save-vdo-fot-wrapper">
              <div className="fot-btn">
                <button
                  className="cbtn brd-btn dismiss"
                  onClick={() => handleDiscadRecording()}
                >
                  <span>Don’t Save</span>
                </button>
                <button
                  className="cbtn thm-btn save-vdo"
                  onClick={() => handleVagaroDriveFlag()}
                >
                  <span>Save to Vagaro Drive</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {showIframe && <IframeModal />}
      <DrivePlanPopupModal
        show={drivePlanModalShow}
        onHide={() => setDrivePlanModalShow(false)}
        setdriveplanmodalshow={setDrivePlanModalShow}
        drivesizecalculate={driveSizeCalculate}
        vagarodriveplanlist={vagaroDrivePlanList}
        uploaddrivecontainername={uploadDriveContainerName}
        setstoragedigit={setStorageDigit}
        handleSavetoDrive={handleSavetoDrive}
        uploadFolderName={uploadFolderName}
        uploadDriveContainerName={uploadDriveContainerName}
        usageStorageDigitInKb={usageStorageDigitInKb}
        storageDigit={storageDigit}
      />
      {exitModalShow && (
        <ClassAppointmentExitPopup
          show={exitModalShow}
          onHide={() => setExitModalShow(false)}
          handlefunction={() => {
            const currentPath = window.location.pathname;
            const newPath = currentPath.replace("/meeting", "/feedbackhost");
            navigate(newPath + window.location.search, {
              state: { driveStatus: true },
            });
          }}
          exitFunction={setExitModalShow}
          message={"Are you sure you want to save the recording ?"}
          buttontext={"Save File"}
          headtext={"Save the Recording"}
        />
      )}
    </>
  );
}
export default memo(SaveRecordingScreen);
